import { useContext, useEffect, useState } from "react";
import { FAQContext, FAQContextType } from "../provider/FAQProvider";
import { getSearchMessage } from "../../Helpers/utils";

export type FAQResultsModel = {
  resultMessage: string,
  noResultMessage: string
}

export default function FAQResults({ resultMessage, noResultMessage }: FAQResultsModel) {
  const [message, setMessage] = useState<string>('');
  const { searchTerm, faqs, totalRecords } = useContext(FAQContext) as FAQContextType;

  useEffect(() => {
    new Foundation.Accordion($('.accordion'));

    if (faqs && faqs.length > 0 && searchTerm.length > 0) {
      setMessage(getSearchMessage(searchTerm, totalRecords, noResultMessage, resultMessage));
    } else {
      setMessage('');
    }
  }, [faqs])

  return (
    <div className="faq-questions">
      { message.length > 0 && 
        <div dangerouslySetInnerHTML={ { __html: message}} >
        </div>
      }
      <ul className="accordion" data-accordion data-allow-all-closed="true">
        <>
          {(faqs && faqs.length > 0) && faqs.map((answer, index) => {
            return (
              <li key={`faq-${index}`} className="accordion-item" data-accordion-item>
                <a href="#" className="accordion-title">{answer.name}</a>
                <div className="accordion-content" data-tab-content>
                  <div dangerouslySetInnerHTML={ { __html: answer.properties['answer']}} >
                  </div>
                  <div className="text-right">
                      <a href={answer.url} className="shrink">READ MORE &gt; </a>
                  </div>
                </div>
              </li>
            )
          })}
        </>
      </ul>
    </div>
  )
}